
const digest = 'ee10ba3bff4cac09655be4105414e50a87ed7b521af31fb5f58ca802a8ef325f';
const classes = {"wrapper":"_wrapper_8uwyu_1"};
const css = `._wrapper_8uwyu_1 {
  padding: 24px;
  border-top: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  